import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import Modal from '~/Containers/Global/Modal/Modal';
import { PARENT_DELETE_WARNING_MODAL } from '~/Config/Modals';
import { closeModal } from '~/Redux/Modules/Modal';
import Button from '~/Components/Global/Form/Button';

import './ParentDeleteWarning.scss';

export const ParentDeleteWarning = ({ modalId = PARENT_DELETE_WARNING_MODAL, onConfirm }) => {
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeModal(modalId));
  };

  const renderActionButtons = () => {
    return (
      <div>
        <div className="col-xs-6 align-right">
          <Button
            type="button"
            text="Cancel"
            className="default false"
            onClick={() => handleCloseModal()}
            actionText="Cancel"
          />
        </div>
        <div className="col-xs-6 align-left">
          <Button
            type="button"
            text="OK"
            className="default ok false"
            onClick={() => {
              if (onConfirm) onConfirm();
              handleCloseModal();
            }}
            actionText="OK"
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      overlayClassName="parent-delete-warning-modal"
      id={modalId}
      ariaHideApp={false}
      onClose={() => {}}
    >
      <>
        <h1>Warning:</h1>
        <p className="notes">
          Deleting this task will also delete its subtasks. Do you want to continue?
        </p>
        <div className="actions">{renderActionButtons()}</div>
      </>
    </Modal>
  );
};

const mapStateToProps = ({ Modal }) => ({
  onConfirm: Modal.modalData?.onConfirm,
});

ParentDeleteWarning.propTypes = {
  modalId: PropTypes.string,
  // Not isRequired: the modal is always mounted, so onConfirm is undefined while
  // idle (no modalData). The OK handler guards with `if (onConfirm)`.
  onConfirm: PropTypes.func,
};

export default connect(mapStateToProps)(ParentDeleteWarning);
